import { Controller, useFormContext } from 'react-hook-form';
import Editor, { type EditorFieldProps } from '../../common/Editor';

export const EditorField = ({ name, ...props }: EditorFieldProps) => {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState }) => {
                return (
                    <Editor
                        {...props}
                        name={field.name}
                        value={field.value || ''}
                        onChange={value => {
                            field.onChange(value);
                        }}
                        errorElement={fieldState.error?.message}
                    />
                );
            }}
        />
    );
};

export default EditorField;
